// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.st-media-display-container {
    text-align: left;
    margin: 20px;
    font-family: Arial, Helvetica, sans-serif;
  }
  
  .st-dropdown-label {
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    margin-left: 0px;
  }
  
  select {
    padding: 8px;
    font-size: 14px;
    cursor: pointer;
    font-family: Arial, Helvetica, sans-serif;
  }
  
  .st-media-preview {
    padding: 20px;
    border: 1px solid ;
    border-radius: 8px;
    margin-top: 20px;
    background: none;
  }
  
  .slideshow, .grid-layout, .horizontal-scroll, .lightbox {
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif;
    padding: 20px;
    background-color: none;
    border-radius: 5px;
  }
  
  .media-display-layout {
    margin-top: 40px;
    margin-left: 40px;
    width: 300px;
    height: 300px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/MediaDisplay.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,yCAAyC;IACzC,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IAEE,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,aAAa;EACf","sourcesContent":[".st-media-display-container {\n    text-align: left;\n    margin: 20px;\n    font-family: Arial, Helvetica, sans-serif;\n  }\n  \n  .st-dropdown-label {\n    font-size: 16px;\n    font-family: Arial, Helvetica, sans-serif;\n    font-weight: bold;\n    margin-left: 0px;\n  }\n  \n  select {\n    padding: 8px;\n    font-size: 14px;\n    cursor: pointer;\n    font-family: Arial, Helvetica, sans-serif;\n  }\n  \n  .st-media-preview {\n    margin-top: 20px;\n    padding: 20px;\n    border: 1px solid ;\n    border-radius: 8px;\n    margin-top: 20px;\n    background: none;\n  }\n  \n  .slideshow, .grid-layout, .horizontal-scroll, .lightbox {\n    font-size: 16px;\n    font-family: Arial, Helvetica, sans-serif;\n    padding: 20px;\n    background-color: none;\n    border-radius: 5px;\n  }\n  \n  .media-display-layout {\n    margin-top: 40px;\n    margin-left: 40px;\n    width: 300px;\n    height: 300px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
